import React, { useState } from "react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function Careers() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { ...form, kind: "career" });
      toast.success("Thanks - we'll be in touch.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MarketingLayout>
      <section className="pt-28 pb-12 max-w-5xl mx-auto px-6 lg:px-10">
        <p className="text-xs uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold mb-4">Careers</p>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tighter text-[#1A1A2E] leading-[0.95]">
          WYLO is growing.<br />Quietly. Deliberately.
        </h1>
        <p className="mt-6 text-lg text-[#555568] max-w-2xl leading-relaxed">
          We're looking for people who believe that great work deserves great focus. If that sounds like you, we'd love to hear from you.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 lg:px-10 pb-32">
        <form onSubmit={submit} className="rounded-xl border border-[#E8ECF2] bg-white p-8 space-y-5" data-testid="careers-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <Label htmlFor="name">Name</Label>
              <Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="careers-name" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="careers-email" />
            </div>
          </div>
          <div>
            <Label htmlFor="role">Role you're interested in</Label>
            <Input id="role" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="e.g. Senior Frontend Engineer" data-testid="careers-role" />
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required data-testid="careers-message" />
          </div>
          <p className="text-xs text-[#555568]">CV upload: coming soon. In the meantime, please paste a link to your portfolio or LinkedIn in your message.</p>
          <Button disabled={loading} className="bg-[#2C6BAC] hover:bg-[#1A3A5C] text-white" data-testid="careers-submit">
            {loading ? "Sending…" : "Apply / Get in touch"}
          </Button>
        </form>
      </section>
    </MarketingLayout>
  );
}
